var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('button',{staticClass:"detail",on:{"click":function($event){return _vm.open()}}},[_vm._v(_vm._s(_vm.buttonTitle)),_c('img',{attrs:{"src":_vm.iconSrc,"aria-hidden":"true"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }